import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { getCookie } from "../../utils/cookies";

const AuthRoot = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const access_token = getCookie("StoreDashboardAccessToken");
    if (access_token) {
      navigate("/dashboard");
    }
  }, [navigate]);
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default AuthRoot;
